import styled from "styled-components";

export const TabTopContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-direction: row;
  flex-direction: column;

  @media (min-width: 800px) {
    flex-direction: row;
  }
`;
